import { Select } from 'radix-ui';
import type { ReactNode } from 'react';
import {
  StyledCheckIcon,
  StyledContent,
  StyledItem,
  StyledItemIndicator,
  StyledItemText,
  StyledTrigger,
  StyledTriggerWrapper,
  StyledViewport,
} from './ShipmentSelector.styles';

interface Option {
  value: string;
  label: string;
}

interface ShipmentSelectorProps<T extends string> {
  options: Array<Option>;
  value: T;
  onValueChange: (value: T) => void;
  renderTrigger: () => ReactNode;
  sideOffset?: number;
}

export function ShipmentSelector<T extends string>({
  options,
  value,
  onValueChange,
  renderTrigger,
  sideOffset = 5,
}: ShipmentSelectorProps<T>) {
  return (
    <Select.Root value={value} onValueChange={onValueChange}>
      <StyledTrigger>
        <StyledTriggerWrapper>{renderTrigger()}</StyledTriggerWrapper>
      </StyledTrigger>

      <Select.Portal>
        <StyledContent position='popper' sideOffset={sideOffset}>
          <StyledViewport>
            {options.map((option) => {
              const isSelected = option.value === value;

              return (
                <StyledItem key={option.value} value={option.value} $isSelected={isSelected}>
                  <StyledItemText>{option.label}</StyledItemText>
                  <StyledItemIndicator>
                    <StyledCheckIcon width={16} height={16} />
                  </StyledItemIndicator>
                </StyledItem>
              );
            })}
          </StyledViewport>
        </StyledContent>
      </Select.Portal>
    </Select.Root>
  );
}
